// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__1iy4h","row":"Grid_row__GtO9Z","start":"Grid_start__-iD2S","col":"Grid_col__HXzgc","confirm":"Grid_confirm__sMUw1","buttons":"Grid_buttons__Ohm1P"};